<template>
  <div :id="id" v-clickaway="!disableClickAway && close">
    <slot/>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue"

const props = defineProps({
  id: { type: String, required: true },
  disableClickAway: Boolean,
})

const details = ref()

const close = () => {
  details.value.forEach(detailElement => {
    detailElement.open = false
  })
}

onMounted(() => {
  details.value = document.querySelectorAll(`#${props.id} details`)

  details.value.forEach(detailElement => {
    detailElement.addEventListener("toggle", toggleOpenOneOnly)
  })

  function toggleOpenOneOnly() {
    if (this.open) {
      details.value.forEach(detail => {
        if (detail != this && detail.open) {
          detail.open = false
        }
      })
    }
  }
})
</script>
